<template>
  <van-config-provider :theme-vars="themeVarsMix">
    <van-nav-bar
      :title="title"
      :left-text="leftText"
      :left-arrow="leftArrow"
      :border="border"
      :safe-area-inset-top="safeAreaInsetTop"
      @click-left="onClickLeft"
    />
  </van-config-provider>
</template>

<script>
import { toRefs } from "vue"
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    leftText: {
      type: String,
    },
    leftArrow: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: false,
    },
    safeAreaInsetTop: {
      type: Boolean,
      default: true,
    },
    themeVars: {
      type: Object,
    },
  },
  setup(props) {
    let { themeVars } = toRefs(props)
    let themeVarsMix = {
      navBarHeight: "44px",
      navBarArrowSize: "24px",
      navBarTitleFontSize: "18px",
      navBarIconColor: "#333",
      navBarTitleTextColor: "#333",
      navBarZIndex: 2,
    }

    themeVarsMix = Object.assign({}, themeVarsMix, themeVars.value)

    const onClickLeft = () => history.back()

    return {
      themeVarsMix,
      onClickLeft,
    }
  },
}
</script>

<style lang="less" scoped></style>
